import React from "react";

import { MdmDeviceDto, MdmDeviceHistory } from "gql/generated/types";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Link } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import { DATE_FORMATTER_SECONDS } from "utils/constants";
import { parseToLocalZoneDateTime } from "utils/time-utils";
import { TableColumn } from "../utils/types";

type MigrationHistoryProps = {
  device: Partial<MdmDeviceDto>;
};

const MigrationHistory: React.FC<MigrationHistoryProps> = ({ device }) => {

  const objectIdentifierTemplate = (rowData: MdmDeviceHistory) => (
    <Link to={`../objects/${rowData.objectId}`}>{rowData.objectIdentifier}</Link>
  );

  const columns: TableColumn<MdmDeviceHistory>[] = [
    {
      field: "timestamp",
      header: T("word.timestamp"),
      columnKey: "timestamp",
      sortable: true,
      body: data => parseToLocalZoneDateTime(data.timestamp).format(DATE_FORMATTER_SECONDS),
    },
    {
      field: "objectIdentifier",
      header: T("word.object-identifier"),
      body: objectIdentifierTemplate,
      columnKey: "objectIdentifier",
      sortable: true,
    },
    {
      field: "address",
      header: T("word.address"),
      columnKey: "address",
      sortable: true,
    },
    {
      field: "value",
      header: T("word.reading"),
      columnKey: "value",
      sortable: true,
    },
  ];

  const migrationRecords = device.history?.reduce(
    (array, record) => {
      if (!array.find(r => r?.timestamp === record?.timestamp) && record) array.push(record);
      return array;
    },
    [] as MdmDeviceHistory[]
  );

  return (
    <DataTable
      value={migrationRecords}
      sortField="timestamp"
      sortOrder={-1}
      stripedRows
      paginator
      rows={10}
      reorderableColumns
      rowsPerPageOptions={[5, 10, 25, 50]}
      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
      currentPageReportTemplate={T("table.page-report-template", {
        first: "{first}",
        last: "{last}",
        totalRecords: "{totalRecords}",
      })}
      size="small"
    >
      {columns.map(col => (
        <Column key={col.columnKey} {...col} />
      ))}
    </DataTable>
  );
};

export default MigrationHistory;
